import React, { useState, useEffect, useMemo, useImperativeHandle } from 'react';
import { useContactModel } from '@web-common/hooks/useContactModel';
import lodashGet from 'lodash/get';
import { CustomerAndClueSidebar } from '@/components/Layout/Customer/components/sidebar/customerAndClueSidebar';
import { CommonSidebar } from '@/components/Layout/Customer/components/sidebar/commonSidebar';
import { PageLoading } from '@/components/UI/Loading';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
import { refreshContactDataByEmails } from '@web-common/state/reducer/contactReducer';
import { getMainAccount } from '@web-common/components/util/contact';
import { removeAllMiniDrawer, Module } from '@lxunit/app-l2c-crm';
import { RoleScoreMap, WaCrmLabelTypeMap, apiHolder, apis, } from 'api';
import { useAppDispatch } from '@web-common/state/createStore';
import { getPrivilegeAsync } from '@web-common/state/reducer/privilegeReducer';
import ErrorBoundary from '@web-common/hooks/ErrorBoundary';
const systemApi = apiHolder.api.getSystemApi();
const dataTrackerApi = apiHolder.api.requireLogicalApi(apis.dataTrackerApiImp);
export var RightSidebarScene;
(function (RightSidebarScene) {
    RightSidebarScene["EmailPlus"] = "EmailPlus";
    RightSidebarScene["WaManage"] = "WaManage";
    RightSidebarScene["WaBsp"] = "WaBsp";
})(RightSidebarScene || (RightSidebarScene = {}));
export const CurrentMailIdContext = React.createContext({ id: '', hiddenSaleSettingBtn: false, onSideBarAction: () => { }, isWA: false, scene: RightSidebarScene.EmailPlus });
const RightSidebar = React.forwardRef((props, ref) => {
    var _a;
    const { style: styleFromProps, email, _account, name, replyToMail, id, noBorder, hiddenSaleSettingBtn, scene = RightSidebarScene.EmailPlus, crmLabels = [], crmLabelsLoading = false, onSideBarAction = () => { }, quickCreateData, fromWhatsApp, toWhatsApp, waContainer = '#waChatContainer', waHistoryMembers, needGlobalSearch, } = props || {};
    const dispatch = useAppDispatch();
    const asideContactModel = useContactModel({ email, _account });
    const [loading, setLoading] = useState(false);
    const isWA = useMemo(() => [RightSidebarScene.WaBsp, RightSidebarScene.WaManage].includes(scene), [scene]);
    const isMailPlus = useMemo(() => RightSidebarScene.EmailPlus === scene, [scene]);
    const [waItemList, setWaItemList] = useState([]);
    useEffect(() => {
        if (isWA) {
            setLoading(false);
        }
        else if (isMailPlus) {
            if (!asideContactModel) {
                setLoading(true);
            }
            else {
                setLoading(false);
            }
        }
    }, [asideContactModel, isWA]);
    useEffect(() => {
        if (isWA) {
        }
        else if (isMailPlus && email) {
            removeAllMiniDrawer(Module.Email);
        }
    }, [email]);
    useEffect(() => {
        var _a;
        if (process.env.BUILD_ISEDM || ((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion)) {
            dispatch(getPrivilegeAsync());
        }
    }, []);
    const _needGlobalSearch = useMemo(() => {
        var _a;
        if ((_a = systemApi.doGetProductInfo()) === null || _a === void 0 ? void 0 : _a.navigateVersion) {
            return needGlobalSearch;
        }
        else {
            return true;
        }
    }, [needGlobalSearch]);
    const getRoleByScore = (crmLbs) => {
        if (!(crmLbs === null || crmLbs === void 0 ? void 0 : crmLbs.length))
            return '';
        const highestScoreLb = crmLbs.reduce((p, c) => {
            const pScore = RoleScoreMap[WaCrmLabelTypeMap[Number(p.email_label)]] || 0;
            const cScore = RoleScoreMap[WaCrmLabelTypeMap[Number(c.email_label)]] || 0;
            return pScore > cScore ? p : c;
        });
        return WaCrmLabelTypeMap[Number(highestScoreLb.email_label)];
    };
    const genEmailRolefromWaCrmLabels = (crmLbs) => {
        const crmItemList = crmLbs.filter(item => WaCrmLabelTypeMap[item.email_label] == emailRole);
        return (crmItemList.map(crmLabel => {
            return {
                companyId: String(crmLabel.id),
                companyName: crmLabel.company_name,
                leadsName: crmLabel.detail_name,
                whats_app: crmLabel.whats_app,
                detailId: String(crmLabel.detail_id),
            };
        }) || []);
    };
    useEffect(() => {
        dataTrackerApi.track('right_side_bar_wa_crm_loading_', {
            action: { loading, crmLabelsLoading, isWA },
        });
    }, [loading, crmLabelsLoading]);
    const refreshCrmLabels = () => {
        const newLbs = genEmailRolefromWaCrmLabels(crmLabels);
        if (newLbs === null || newLbs === void 0 ? void 0 : newLbs.length) {
            setWaItemList(newLbs);
        }
    };
    useImperativeHandle(ref, () => ({
        refreshCrmLabels,
    }));
    const crmLabelIds = useMemo(() => {
        if (crmLabels === null || crmLabels === void 0 ? void 0 : crmLabels.length) {
            return crmLabels.map(lb => lb.id).join(',');
        }
        return '';
    }, [crmLabels]);
    useEffect(() => {
        const newLbs = genEmailRolefromWaCrmLabels(crmLabels);
        setWaItemList(newLbs);
    }, [crmLabelIds]);
    useMsgRenderCallback('syncEdmMailSideData', ev => {
        var _a, _b, _c;
        if (isMailPlus) {
            const _email = (_a = ev.eventData) === null || _a === void 0 ? void 0 : _a.email;
            const _name = (_b = ev.eventData) === null || _b === void 0 ? void 0 : _b.name;
            const account = ((_c = ev.eventData) === null || _c === void 0 ? void 0 : _c.account) || getMainAccount();
            const currentAccount = _account || getMainAccount();
            if (_email && account === currentAccount) {
                refreshContactDataByEmails({
                    [account]: [_email],
                }, new Map([[_email, _name || _email]]));
            }
        }
    });
    const emailRole = useMemo(() => {
        if (isMailPlus) {
            return lodashGet(asideContactModel, 'customerOrgModel.role', '');
        }
        else if (isWA) {
            return getRoleByScore(crmLabels);
        }
    }, [isMailPlus, isWA, (_a = asideContactModel === null || asideContactModel === void 0 ? void 0 : asideContactModel.customerOrgModel) === null || _a === void 0 ? void 0 : _a.role, crmLabelIds]);
    const visibleCustomerSide = ['myCustomer', 'colleagueCustomer', 'openSeaCustomer', 'colleagueCustomerNoAuth'].includes(emailRole);
    const visibleClueSide = ['myClue', 'colleagueClue', 'openSeaClue', 'colleagueClueNoAuth'].includes(emailRole);
    return (React.createElement(React.Fragment, null,
        React.createElement(CurrentMailIdContext.Provider, { value: { id: id || '', isWA, hiddenSaleSettingBtn, onSideBarAction, fromWhatsApp, toWhatsApp, scene: scene } },
            React.createElement(React.Fragment, null,
                React.createElement(ErrorBoundary, { name: "RightSidebar" }, visibleCustomerSide || visibleClueSide ? (React.createElement(CustomerAndClueSidebar, { style: styleFromProps, noBorder: noBorder, email: email, name: name || '', _account: _account, setLoading: isLoading => {
                        setLoading(isLoading);
                    }, scene: scene, waItemList: waItemList, waContainer: waContainer, waEmailRole: emailRole, waHistoryMembers: waHistoryMembers, toWhatsApp: (waItemList === null || waItemList === void 0 ? void 0 : waItemList.length) ? waItemList[0].whats_app : toWhatsApp, onSideBarAction: onSideBarAction, needGlobalSearch: _needGlobalSearch })) : (React.createElement(CommonSidebar, { style: styleFromProps, noBorder: noBorder, email: email || '', name: name || '', replyToMail: replyToMail, isWA: isWA, waContainer: waContainer, quickCreateData: quickCreateData, toWhatsApp: toWhatsApp, waHistoryMembers: waHistoryMembers, _account: _account, setLoading: isLoading => {
                        setLoading(isLoading);
                    }, needGlobalSearch: _needGlobalSearch }))),
                loading || crmLabelsLoading ? React.createElement(PageLoading, null) : null))));
});
export default RightSidebar;
